"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("typeface-roboto");

var _material = require("@mui/material");

var _reactRedux = require("react-redux");

var _EmailPreviewWarningBar = _interopRequireDefault(require("../Shared/components/EmailPreviewWarningBar"));

var _EmailPreview = _interopRequireDefault(require("../Shared/components/EmailPreview"));

var _giftEmailPreview = require("./store/giftEmailPreview.actions");

var _giftEmailPreview2 = require("./store/giftEmailPreview.selectors");

var styles = {
  root: {
    margin: '30px auto 111px auto',
    width: 890,
    minHeight: 500
  },
  loaderWrapper: {
    pt: 25,
    mx: 'auto',
    textAlign: 'center'
  },
  loader: {
    margin: '0 auto'
  }
};

var GiftEmailPreview = function GiftEmailPreview(_ref) {
  var giftId = _ref.giftId,
      _ref$provider = _ref.provider,
      provider = _ref$provider === void 0 ? 'default' : _ref$provider;
  var dispatch = (0, _reactRedux.useDispatch)();
  var isPending = (0, _reactRedux.useSelector)(_giftEmailPreview2.getIsPending);
  var isFulfilled = (0, _reactRedux.useSelector)(_giftEmailPreview2.getIsFulfilled);
  var previewData = (0, _reactRedux.useSelector)(_giftEmailPreview2.getEmailPreviewData);
  var senderFullName = ((previewData === null || previewData === void 0 ? void 0 : previewData.sendAs) || (previewData === null || previewData === void 0 ? void 0 : previewData.sender) || {}).fullName;
  (0, _react.useEffect)(function () {
    if (giftId) {
      dispatch((0, _giftEmailPreview.fetchEmailPreviewData)({
        giftId,
        provider
      }));
    }
  }, [giftId, provider, dispatch]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_EmailPreviewWarningBar.default, null), /*#__PURE__*/_react.default.createElement(_material.Paper, {
    sx: styles.root,
    elevation: 2
  }, isPending && /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.loaderWrapper
  }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
    sx: styles.loader
  })), isFulfilled && (previewData === null || previewData === void 0 ? void 0 : previewData.hasIntegration) && /*#__PURE__*/_react.default.createElement(_EmailPreview.default, {
    subject: (previewData === null || previewData === void 0 ? void 0 : previewData.subject) || '',
    body: (previewData === null || previewData === void 0 ? void 0 : previewData.body) || '',
    senderFullName: senderFullName || ''
  }), isFulfilled && !(previewData !== null && previewData !== void 0 && previewData.hasIntegration) &&
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  _react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: (previewData === null || previewData === void 0 ? void 0 : previewData.body) || ''
    }
  })));
};

var _default = GiftEmailPreview;
exports.default = _default;